<div class="accordion">
    <div class="image">
        <img src="/assets/images/extensions/help_simple@2x.png" />
    </div>
    <div class="ui segment">
        <div class="title" (click)="setActiveSection('first')">
            <h3>Using this Plugin</h3>
            <div class="arrow" [ngClass]="{ right: activeSection !== 'first', down: activeSection === 'first' }"></div>
        </div>
        <div class="content" [class.hidden]="activeSection !== 'first'">
            <div class="divider"></div>

            <div class="item">
                <div class="icon">
                    <i class="big icon envelope open outline"></i>
                </div>
                <div class="body">
                    <h4>Share</h4>
                    <p>Copy your personal scheduling link or share available meeting times directly to email.</p>
                </div>
            </div>

            <div class="item">
                <div class="icon">
                    <i class="big icon calendar plus outline"></i>
                </div>
                <div class="body">
                    <h4>Schedule</h4>
                    <p>
                        Quickly schedule a meeting with any contact. Add guests, select your meeting type and
                        CalendarHero will find the best time to meet.
                    </p>
                </div>
            </div>

            <div class="item">
                <div class="icon"></div>
                <div class="body">
                    <p class="help">
                        <a
                            href="https://faq.calendarhero.com/hc/en-us/articles/4430375890971-How-does-the-Microsoft-Outlook-Plugin-Work-"
                            target="_blank"
                            >Need more help? View the FAQ</a
                        >
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="ui segment">
        <div class="title" (click)="setActiveSection('second')">
            <h3>Custom Settings</h3>
            <div
                class="arrow"
                [ngClass]="{ right: activeSection !== 'second', down: activeSection === 'second' }"
            ></div>
        </div>
        <div class="content" [class.hidden]="activeSection !== 'second'">
            <div class="divider"></div>
            <p>
                <a href="https://app.calendarhero.com" target="_blank">Log in to the CalendarHero web app</a> to
                customize your settings and manage your accounts.
            </p>
            <p>
                For the best experience we recommend
                <a href="https://app.calendarhero.com/settings/meeting" target="_blank"
                    >personalizing your meeting preferences.</a
                >
            </p>
        </div>
    </div>
</div>
